const CARD_VALUES = ["A", "K", "Q", "J", "T", "9", "8", "7", "6", "5", "4", "3", "2"];
const CARD_SUITS = ["c", "d", "h", "s"];

const ACTIONS = {
  check: "Check",
  bet: "Bet",
  call: "Call",
  fold: "Fold",
};

const COLOR_SCHEMES = {
  default: ["#ff5050", "#2828d7", "#00a000", "#4d4d4d"],
};

const RANGEGROUP_TYPES = {
  default: {
    label: "Postflop Aggressor",
    colorScheme: "default",
    subranges: [
      {
        label: "Premium Made",
        action: ACTIONS.bet,
      },
      {
        label: "Draw",
        action: ACTIONS.bet,
      },
      {
        label: "Marginal Made",
        action: ACTIONS.check,
      },
      {
        label: "Junk",
        action: ACTIONS.check,
      },
    ],
  },
};

export { CARD_VALUES, CARD_SUITS, COLOR_SCHEMES, RANGEGROUP_TYPES };
